export const STATUS_FILTERS = [
  { value: "pending", label: "Pending" },
  { value: "all", label: "All" },
  { value: "applied", label: "Applied" },
  { value: "rejected", label: "Rejected" },
];

export const statusQueryParam = (filter) => {
  if (!filter || filter === "pending") return undefined;
  return filter;
};

export const buildRows = (records) =>
  (records || []).map((record) => {
    const action = lastAction(record);
    return {
      id: `${record.companyId}/${record.id}`,
      title: record.title,
      key: record.key,
      companyId: record.companyId,
      prNumbers: record.prNumbers || [],
      githubLink: record.githubLink || null,
      stagedBy: record.stagedBy?.email || "",
      stagedAt: record.stagedAt,
      status: record.status,
      stale: Boolean(record.stale),
      lastActionLabel: action?.label ?? "",
      lastActionBy: action?.email ?? "",
      lastActionAt: action?.at ?? "",
      record,
    };
  });

export const actionsForStatus = (status) => ({
  approve: ["staged", "failed"].includes(status),
  reject: ["staged", "approved", "failed"].includes(status),
  edit: ["staged", "approved", "failed"].includes(status),
});

export const approvedSummaries = (records) =>
  (records || [])
    .filter((record) => record.status === "approved")
    .map((record) => ({
      id: record.id,
      companyId: record.companyId,
      title: record.title,
      key: record.key,
      prNumbers: record.prNumbers || [],
      stale: Boolean(record.stale),
    }));

export const describeApplyResults = (results, records) => {
  const titles = new Map(
    (records || []).map((record) => [
      `${record.companyId}/${record.id}`,
      record.title,
    ])
  );
  return (results || []).map((result) => ({
    id: result.id,
    companyId: result.companyId,
    key: result.key,
    title: titles.get(`${result.companyId}/${result.id}`),
    outcome: result.outcome,
    appliedVersionId: result.appliedVersionId,
    failureReason: result.failureReason,
  }));
};

export const uniqueValues = (rows, field) =>
  [...new Set((rows || []).map((row) => row?.[field]).filter(Boolean))].sort();

const ACTION_STAMPS = [
  { label: "Staged", by: "stagedBy", at: "stagedAt" },
  { label: "Edited", by: "editedBy", at: "editedAt" },
  { label: "Approved", by: "approvedBy", at: "approvedAt" },
  { label: "Rejected", by: "rejectedBy", at: "rejectedAt" },
  { label: "Applied", by: "appliedBy", at: "appliedAt" },
];

export const lastAction = (record) => {
  if (!record) return null;
  let latest = null;
  for (const stamp of ACTION_STAMPS) {
    const at = record[stamp.at];
    if (at && (!latest || at >= latest.at)) {
      latest = {
        label: stamp.label,
        email: record[stamp.by]?.email ?? "unknown",
        at,
      };
    }
  }
  return latest;
};

export const parseEditedData = (text) => {
  let data;
  try {
    data = JSON.parse(text);
  } catch (error) {
    return { valid: false, error: error.message };
  }
  if (data === null || typeof data !== "object" || Array.isArray(data)) {
    return { valid: false, error: "Config must be a JSON object" };
  }
  return { valid: true, data };
};
